import { graphqlClient } from '@/lib/graphql-client';
import { buildGetCtcLevelsQuery } from '../graphql/queries';
import {
  DELETE_CTC_LEVEL_MUTATION,
  INSERT_CTC_LEVEL_MUTATION,
  UPDATE_CTC_LEVEL_MUTATION,
} from '../graphql/mutations';
import {
  CtcLevelInsertInput,
  CtcLevelsPagingResult,
  CtcLevelUpdateInput,
  GetCtcLevelsParams,
} from '../types/ctc-level.types';

export const getCtcLevels = async (
  params: GetCtcLevelsParams
): Promise<{ CtcLevels: CtcLevelsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetCtcLevelsQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ CtcLevels: CtcLevelsPagingResult }>;
};

export const createCtcLevel = async (input: CtcLevelInsertInput) => {
  return graphqlClient.mutate({ query: INSERT_CTC_LEVEL_MUTATION, variables: { input } });
};

export const updateCtcLevel = async (params: { itemId: string; input: CtcLevelUpdateInput }) => {
  const filter = JSON.stringify({ _id: params.itemId });
  return graphqlClient.mutate({
    query: UPDATE_CTC_LEVEL_MUTATION,
    variables: { filter, input: params.input },
  });
};

export const deleteCtcLevel = async (itemId: string) => {
  const filter = JSON.stringify({ _id: itemId });
  return graphqlClient.mutate({
    query: DELETE_CTC_LEVEL_MUTATION,
    variables: { filter, input: { isHardDelete: false } },
  });
};
